import React, { useState, useEffect } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Assignment } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { Paper } from '@material-ui/core';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  paper: {
    padding: '0px 11px 4px 10px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px'
  },
  detail: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px',
      marginRight: '10px',
      color: '#000000bf',
      fontWeight: 'bold',
      fontSize: '15px'
    }
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Fecha', accessor: 'created_at', width: 140 },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 110 },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'Unid.', accessor: 'quantity', width: 80, align: 'center' },
  { Header: 'Precio', accessor: 'price', width: 80, align: 'right' },
  { Header: 'P./Igv', accessor: 'price_without_igv', width: 80, align: 'right' },
  { Header: 'T. Migrado', accessor: 'total_migrate', width: 110, align: 'right' },
  { Header: 'Mto. sin Igv', accessor: 'amount_without_igv', width: 110, align: 'right' },
  { Header: 'T. Igv', accessor: 'total_igv', width: 90, align: 'right' },
  { Header: 'Monto', accessor: 'total_detail', width: 90, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function SaleProductDetail(props) {
  const classes = useStyles();
  const { product } = props;

  const [sale, setSale] = useState({});
  const [saleDetails, setSaleDetails] = useState([]);

  async function getSale() {
    let response = await wsFindBy(`sale/product-consolidate/${product.idProduct}`, {
      sale_date: product.sale_date,
      base_zone_id: product.base_zone_id
    });
    if (response.success) {
      setSale({
        ...response.data,
        total: response.data.details.reduce((a, b) => a + parseFloat(b.total_detail), 0)
      });
      setSaleDetails(response.data.details);
    }
  }

  useEffect(() => {
    getSale();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          Detalle de ventas del producto <b>{sale.ItemName} / </b> ({sale.ordenes} órdenes)
        </h4>
      </CardHeader>
      <CardBody>
        <GridContainer style={{ marginBottom: '15px' }}>
          <GridItem xs={12} lg={2} className={classes.detail}>
            <Paper className={classes.paper}>
              <h5>Zona:</h5>
              <span>
                {sale.base_zone_code} - {sale.base_zone_description}
              </span>
            </Paper>
          </GridItem>
          <GridItem xs={12} lg={4} className={classes.detail}>
            <Paper className={classes.paper}>
              <h5>Producto:</h5>
              <span>
                {sale.ItemCode} - {sale.ItemName}
              </span>
            </Paper>
          </GridItem>
          <GridItem xs={12} lg={4} className={classes.detail}>
            <Paper className={classes.paper}>
              <h5>Proveedor:</h5>
              <span>
                {sale.CardCode} - {sale.CardName}
              </span>
            </Paper>
          </GridItem>
          <GridItem xs={12} lg={2} className={classes.detail}>
            <Paper className={classes.paper}>
              <h5>Total: </h5>
              <span>{currency(sale.total)}</span>
            </Paper>
          </GridItem>
        </GridContainer>
        <ReactTable
          excelName="Detalles-de-pedidos"
          formatDate="DD-MM-YYYY HH:mm:ss"
          defaultWidth={1400}
          columns={columns}
          data={saleDetails.map((item, i) => {
            return {
              num: i + 1,
              created_at: item.created_at,
              SlpName: `${item.SlpCode || ''} - ${item.SlpName || ''}`,
              CardCode: item.CardCode,
              CardName: item.CardName,
              quantity: item.quantity,
              price: currency(item.price),
              price_without_igv: currency(item.price_without_igv),
              total_migrate: currency(item.total_migrate),
              amount_without_igv: currency(item.amount_without_igv),
              total_igv: currency(item.total_igv),
              total_detail: currency(item.total_detail),
              /* type_detail: item.type_detail === 'P' ? 'Paquete' : 'Unidad', */
              actions: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
